import React, { useState } from 'react'
import { connect } from 'react-redux'
import { 
  Delete, 
  LangDeleteEmployeeConfirm, 
  LangDeleteEmployeeConfirm1, 
  LangDeleteEmployeeConfirm2, 
  LangDeleteEmployeeConfirm3, 
  LangImportCancel, 
  LangNotNow, 
  LangReason, 
  LangResetDataFirst, 
  LangYesSure,
  LangSelectReason,
  LangNote,
  LangExplainOtherReason,
  LangReasonMustBeSelected,
} from '../../constant/languange'
import { axiosCompany, mapDispatchToProps, mapStateToProps } from '../../helpers/Common'
import { SpinnerButton } from '../../helpers/Spinner'
import ReactTooltip from 'react-tooltip'
import { ModalApp } from '../../helpers/Input'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { RESIGNATION_REASONS } from '../../constant/PersonnelDeleteConstant'

function PersonnelDeleteComponent({ redux, setState, currentData, getPersonnelsService, ...props }) {
  const [control, setControl] = useState({ showLoad: false })
  const [data, setData] = useState({ deleted_reason: '', deleted_reason_note: '' })
  const [errors, setErrors] = useState({})

  // function
  const deletePersonnelService = (e) => {
    e.preventDefault()
    if (redux.isTemporary) return

    const formData = new window.FormData()
    
    // Gabungkan label kategori dengan catatan jika ada
    let reasonText = getReasonLabel()
    if (data.deleted_reason_note && data.deleted_reason_note.trim()) {
      reasonText += ` - ${data.deleted_reason_note.trim()}`
    }
    
    formData.append('deleted_reason', reasonText)
    formData.append('_method', 'delete')

    setControl(control => ({ ...control, showLoad: true }))
    axiosCompany().post(`personnels/${currentData.id}`, formData)
      .then(() => {
        getPersonnelsService()
        setControl(control => ({ ...control, showLoad: false }))
        props.handleClose()

        if (redux.stats.personnels_count > 0) {
          setState({ isUpdateStats: redux.isUpdateStats + 1 })
        }
      }).catch(e => {
        setControl(control => ({ ...control, showLoad: false }))
        if (e.response?.data?.errors) {
          setErrors(e.response.data.errors)
        }
      })
  }

  // handler
  const handleSelectChange = (e) => {
    setData(currData => ({ ...currData, [e.target.name]: e.target.value }))
    setErrors(currErrors => ({ ...currErrors, [e.target.name]: null }))
  }

  const handleTextChange = (e) => {
    setData(currData => ({ ...currData, [e.target.name]: e.target.value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    
    // Validasi
    const newErrors = {}
    if (!data.deleted_reason) {
      newErrors.deleted_reason = LangReasonMustBeSelected
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }
    
    setControl({ ...control, showModal: 'confirm' })
  }

  const getReasonLabel = () => {
    const reason = RESIGNATION_REASONS.find(r => r.value === data.deleted_reason)
    return reason ? reason.label : data.deleted_reason
  }

  return (
    <>
      <form className='form' onSubmit={handleSubmit} autoComplete='off'>
        <div className='form-group row'>
          <label className='col-sm-3 col-form-label text-lg-right'>{LangReason} <span className='text-danger'>*</span></label>
          <div className='col-sm-8'>
            <select 
              className={`form-control ${errors.deleted_reason ? 'is-invalid' : ''}`}
              name='deleted_reason' 
              value={data.deleted_reason} 
              onChange={handleSelectChange}
              required
            >
              <option value=''>{LangSelectReason}</option>
              {RESIGNATION_REASONS.map(reason => (
                <option key={reason.value} value={reason.value}>{reason.label}</option>
              ))}
            </select>
            {errors.deleted_reason && (
              <div className='invalid-feedback d-block'>{errors.deleted_reason}</div>
            )}
          </div>
        </div>
        
        {data.deleted_reason === 'other' && (
          <div className='form-group row'>
            <label className='col-sm-3 col-form-label text-lg-right'>{LangNote}</label>
            <div className='col-sm-8'>
              <textarea 
                className='form-control' 
                name='deleted_reason_note' 
                value={data.deleted_reason_note} 
                onChange={handleTextChange}
                rows='3'
                placeholder={LangExplainOtherReason}
              />
            </div>
          </div>
        )}
        
        <hr />
        <div className='form-group row'>
          <div className='col-sm-9 offset-md-3'>
            <div>
              {
                redux.isTemporary ?
                  <>
                    <button disabled={true} data-for='tooltip-info-reset-data' data-tip={LangResetDataFirst} type='submit' className='btn btn-danger mr-2'>{(control.showLoad) ? SpinnerButton : null} {Delete}</button>
                    <ReactTooltip id='tooltip-info-reset-data' place='bottom' />
                  </>
                  :
                  <button disabled={control.showLoad} type='submit' className='btn btn-danger mr-2'>{(control.showLoad) ? SpinnerButton : null} {Delete}</button>
              }
              <button disabled={control.showLoad} onClick={() => props.handleClose()} type='button' className={`btn ${redux.darkModeOn ? 'btn-dark' : 'btn-light'}`}>{LangImportCancel}</button>
            </div>
          </div>
        </div>
      </form>
      
      {control.showModal === 'confirm' && (
        <ModalApp
          title={LangDeleteEmployeeConfirm}
          handleClose={() => { setControl({ ...control, showModal: '' }) }}
          size='md'
          body={
            <>
              <p style={{ fontSize: 16 }}>
                {LangDeleteEmployeeConfirm1} <b>{currentData.name}</b> {LangDeleteEmployeeConfirm2} <b>"{getReasonLabel()}"</b>?
              </p>
              {data.deleted_reason_note && (
                <p style={{ fontSize: 14 }} className='text-muted'>
                  {LangNote}: {data.deleted_reason_note}
                </p>
              )}
              <div className={`alert ${redux.darkModeOn ? 'alert-dark' : 'alert-light'} my-2`}>
                <FontAwesomeIcon icon={faInfoCircle} /> {LangDeleteEmployeeConfirm3}.
              </div>
              <hr />
              <div className='d-flex'>
                <button disabled={control.showLoad} className='btn btn-danger mr-2' type='button' onClick={deletePersonnelService}> {control.showLoad ? SpinnerButton : ''} {LangYesSure}</button>
                <button className='btn btn-light mr-2' type='button' onClick={() => { setControl({ ...control, showModal: '' }) }}>{LangNotNow}</button>
              </div>
            </>
          }
        />
      )}
    </>

  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonnelDeleteComponent)
